import React, { useEffect, useState } from "react";
import { Form, Placeholder } from "react-bootstrap";
import {
  DeleteOutlined,
  FileTextOutlined,

} from "@ant-design/icons";
import NoData from "assets/svgs/no_data/NoData";
import GroupManagementCanvas from "./GroupManagementOffCanvas";
import { useGroupManagement } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Button, Popconfirm } from "antd";
import PaginationDiv from "modules/pagination/PaginationDiv";

function GroupManagementTable({
  groupData,
  groupLoading,
  userData,
  userLoading,
}) {
  const { fetchGroupData, deletedGroup } = useGroupManagement();
  const { setToaster } = useToast();
  const [page, newPage] = useState(1);
  const [filterManagementData, setManagementFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [sortedManagementData, setSortedManagementData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setSortedManagementData(groupData);
  }, [groupData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(
      Math.ceil((sortedManagementData?.length || 0) / 10),
      0
    );
    const paginationArrays = sortedManagementData
      ? Array.from({ length: numOfSubarrays }, (_, index) => {
          const start = index * 10;
          const end = start + 10;
          return sortedManagementData?.slice(start, end);
        })
      : [];
    setPageCount(
      Math.max(Math.ceil((sortedManagementData?.length || 0) / 10), 1)
    );
    setManagementFilter(paginationArrays[page - 1]);
  }, [sortedManagementData, page]);

  const handleDeleteGroup = (id) => {
    deletedGroup(id, setToaster, fetchGroupData);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    const filteredData = sortedManagementData.filter((group) =>
      (group?.name || "").toLowerCase().includes(value.toLowerCase()) || (group?.user?.first_name || '').toLowerCase().includes(value.toLowerCase())
    );
    setManagementFilter(filteredData.slice((page - 1) * 10, page * 10));
    setPageCount(Math.max(Math.ceil(filteredData.length / 10), 1));
  };

  const header = ["Group Name", "Supervisor Name", "Actions"];
  return (
    <div>
      <span>
        <Form.Control
          className="form-control" 
          placeholder="Group Name/Suerpvisor"
          onChange={(e) => handleSearch(e.target.value)}
          value={searchTerm}
          style={{ width: "400px" }}
        />
      </span>

      <div>
        <div className="mt-1 shadow rounded mt-3">
          <div className="d-flex table-head rounded-top">
            {header?.map((group) => {
              return (
                <span className="p-3 fs-1 fw-bold text-black flex-1 border-end">
                  {group}
                </span>
              );
            })}
          </div>
          {groupLoading ? (
            <>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
            </>
          ) : filterManagementData && filterManagementData?.length ? (
            filterManagementData?.map((group, index) => {
              return (
                <div
                  className={`d-flex table-row border- border-top-0 ${
                    index === filterManagementData?.length - 1 && `rounded-bottom`
                  }`}
                >
                  <span className="p-3 flex-1 fw-bold text-break text-black text-wrap border-end">
                    {group?.name}
                  </span>
                  <span className="p-3 flex-1 fw-bold text-break text-black text-wrap border-end">
                    {group?.user?.first_name}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    <div className="d-flex">
                      <div className="cursor-pointer text-primary">
                        <GroupManagementCanvas
                          id={group?.id}
                          userData={userData}
                        />
                      </div>
                      <div className="cursor-pointer text-danger">
                        <Popconfirm
                          title={
                            <div>
                              Are you sure you want to delete
                              <div type="danger" strong>
                                {group?.name}
                              </div>
                            </div>
                          }
                          placement="bottom"
                          onConfirm={() => handleDeleteGroup(group?.id)}
                        >
                          <Button
                            danger
                            icon={<DeleteOutlined />}
                            type="link"
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  </span>
                </div>
              );
            })
          ) : (
            <div className="p-3 bg-white rounded-bottom text-center">
              No Data Available <NoData />
            </div>
          )}
        </div>
        <PaginationDiv
          paginationData={{ pageCount: pageCount || 1, page: page }}
          newPage={newPage}
        />
      </div>
    </div>
  );
}

export default GroupManagementTable;
